import React, { FC, useEffect } from 'react';
import { writeStorage } from '@rehooks/local-storage';
import { GoogleLogin, GoogleLoginResponse, GoogleLoginResponseOffline } from 'react-google-login';
import FacebookLogin, { ReactFacebookLoginInfo } from 'react-facebook-login';
import { History, LocationState } from 'history';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

// Models
import { AuthResponse } from '../../../../../models';

// Redux
import { socialLoginAction } from '../../../../../../redux';

// Utils
import { getHost } from '../../../../../../utils';

// Routes
import routes from '../../../../../../routes';

import googleSocial from '../../../../../../assets/images/icons/googlesocial.svg';
import zoomSocial from '../../../../../../assets/images/icons/zoomsocial.svg';
import facebookSocial from '../../../../../../assets/images/icons/facebooksocial.svg';
import { useQuery } from '../../../../../hooks';

const getZoomTokenId = () => new Promise((resolve, reject): void => {
  const width = 640;
  const height = 580;

  const left = (screen.width / 2) - (width / 2);
  const top = (screen.height / 2) - (height / 2);
  let options = ',width=' + width;
  options += ',height=' + height;
  options += ',top=' + top;
  options += ',left=' + left;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.sendToken = resolve;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.sendError = reject;

  window.open(`https://${ getHost() }/auth/social/zoom/popup`, 'Sign In with zoom', options);
});

const responseGoogleFailed = (error: unknown): void => {
  const googleError = error as { error: string };
  if (googleError?.error === 'idpiframe_initialization_failed') return;

  // toast.error('Error during Google authorization');
};

export const AuthSocial: FC = (): JSX.Element => {
  const dispatch = useDispatch();
  const history: History<LocationState> = useHistory();
  const queries = useQuery();

  const redirectToList = (): void => {
    if (queries.get('app-auth')) {
      history.replace({
        pathname: routes.list,
        search: `app-auth=${ queries.get('app-auth') }`,
      });
    } else {
      history.replace(routes.list);
    }
  };

  const loginGoogle = async (response: GoogleLoginResponse | GoogleLoginResponseOffline): Promise<void> => {
    if (response?.code) {
      toast.error('Please check yout internet connection');
      return;
    }

    const result: GoogleLoginResponse = response as GoogleLoginResponse;
    const auth = await dispatch(socialLoginAction(result?.tokenId, 'google'));
    const authResult = auth as unknown as AuthResponse;

    if (authResult?.user?.id) {
      writeStorage('token', authResult?.token);
      redirectToList();
    }
  };

  const proceedZoomAuth = async (): Promise<void> => {
    try {
      const zoomTokenId = await getZoomTokenId();

      const auth = await dispatch(socialLoginAction(zoomTokenId as string, 'zoom'));
      const authResult = auth as unknown as AuthResponse;

      if (authResult?.user?.id) {
        writeStorage('token', authResult?.token);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        delete window.sendToken;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        delete window.sendError;

        redirectToList();
      } else {
        toast.error('Zoom auth error');
      }
    } catch (e: unknown) {
      console.error(e);
      toast.error('Zoom auth error');
    }
  };

  const responseFacebook = async (userInfo: ReactFacebookLoginInfo): Promise<void> => {
    if (userInfo?.accessToken) {
      console.log(userInfo);
      const auth = await dispatch(socialLoginAction(userInfo.accessToken, 'facebook'));
      const authResult = auth as unknown as AuthResponse;

      if (authResult?.user?.id) {
        writeStorage('token', authResult?.token);
        redirectToList();
      } else {
        toast.error('Facebook auth error');
      }
    }
  };

  useEffect((): void => {
    if (queries.get('app-auth') === 'zoom') {
      proceedZoomAuth().then();
    }
  }, [ queries.get('app-auth') ]);

  return (
    <div className="auth-page-social">
      <GoogleLogin clientId="609198922782-4s4dhdj8ntv6muedula9ml2ginfgil3c.apps.googleusercontent.com"
                   buttonText="Login"
                   autoLoad={ queries.get('app-auth') === 'google' }
                   onSuccess={ loginGoogle }
                   onFailure={ responseGoogleFailed }
                   render={ renderProps => (
                     <button onClick={ renderProps.onClick }
                             disabled={ renderProps.disabled }
                             style={ { cursor: 'pointer' } }
                     >
                       <img src={ googleSocial } alt="google" />
                     </button>
                   ) }
                   cookiePolicy={ 'single_host_origin' } />
      <button onClick={ proceedZoomAuth }
              style={ { cursor: 'pointer' } }
      >
        <img src={ zoomSocial } alt="zoom" />
      </button>
      <FacebookLogin appId="731286680933349"
                     textButton=""
                     autoLoad={ queries.get('app-auth') === 'facebook' }
                     fields="name,email,picture"
                     cssClass="my-facebook-button-class"
                     icon={ <img src={ facebookSocial } alt="facebook" style={ { cursor: 'pointer' } } /> }
                     callback={ responseFacebook } />
    </div>
  );
};
